export { default } from "./VirtualSolveInClass";
